// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"FhpLoddvHXa9SZOinUHYw","Comment":"_2AYQvLnxRmRkxGeSzRkgFk","Meta":"_2BO9PNpmlMmkCxCLUwGKun","Message":"_3Dc87OzLzOS9f9kwPelwNc","CommentChildren":"_2erN-7Ese_QqtXkYuKupD4"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Comments/styles.css
// module id = 671
// module chunks = 0